/**
 * Saved plots API — CRUD for plot configs with data snapshots.
 *
 * Each plot has a `scope`:
 *   "branch"  — visible only on the branch where it was created
 *   "project" — visible from every branch
 */

import { apiClient } from "./client";

export type PlotScope = "branch" | "project";

export interface SavedPlotPayload {
  project_id: string;
  title: string;
  chart_type: string;
  config: Record<string, unknown>;
  data_snapshot: Record<string, unknown>[];
  source_node_ids?: string[];
  branch: string;
  scope: PlotScope;
}

export interface SavedPlot {
  id: string;
  project_id: string;
  branch: string;
  scope: PlotScope;
  title: string;
  chart_type: string;
  config: Record<string, unknown>;
  data_snapshot: Record<string, unknown>[];
  source_node_ids: string[];
  image_url: string | null;
  created_at: string;
  updated_at: string | null;
}

export async function createPlot(
  payload: SavedPlotPayload,
): Promise<{ id: string; created_at: string }> {
  return apiClient<{ id: string; created_at: string }>("/plots", {
    method: "POST",
    body: payload,
  });
}

export async function fetchPlots(projectId: string, branch: string): Promise<SavedPlot[]> {
  return apiClient<SavedPlot[]>(`/plots?project_id=${projectId}&branch=${encodeURIComponent(branch)}`);
}

export async function fetchPlot(plotId: string): Promise<SavedPlot> {
  return apiClient<SavedPlot>(`/plots/${plotId}`);
}

export async function deletePlot(plotId: string): Promise<void> {
  await apiClient(`/plots/${plotId}`, { method: "DELETE" });
}
